module.exports = __webpack_public_path__ + "static/media/Minecraft_logo.be64a438.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ServersList/Server/images/Minecraft_logo.svg
// module id = 315
// module chunks = 0